interface IUserWithMetaData {
	metaData?: Record<string, unknown>;
}

/** Checks whether the per-user `metaData.featureFlags` list contains the given flag. */
export const hasUserFeatureFlag = (
	userData: IUserWithMetaData | null | undefined,
	flag: string
): boolean => {
	const featureFlags = userData?.metaData?.['featureFlags'];

	return Array.isArray(featureFlags) && featureFlags.includes(flag);
};
